import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import ContentRenderer from '../components/ContentRenderer';
import { getPostBySlug } from '../api/api';
import './PostPage.css';

const PostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    getPostBySlug(slug)
      .then(data => {
        setPost(data);
        setError(null);
      })
      .catch(err => {
        setError('Gönderi bulunamadı.');
        setPost(null);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  if (loading) {
    return (
      <div className="post-page">
        <div className="post-container">
          <p className="post-loading">yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="post-page">
        <div className="post-container">
          <Link to="/" className="back-link">← geri</Link>
          <p className="post-error">{error || 'Gönderi bulunamadı.'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="post-page">
      <Link to="/" className="back-link">← geri</Link>

      <article className="post-container">
        <div className="post-tape" />

        <div className="post-meta">
          <span className="post-category">{post.category?.toLowerCase()}</span>
          <span className="post-date">{formatDate(post.publishedDate)}</span>
        </div>

        <h1 className="post-title">{post.title}</h1>

        {post.tags && post.tags.length > 0 && (
          <div className="post-tags">
            {post.tags.map(tag => (
              <span key={tag} className="post-tag">{tag}</span>
            ))}
          </div>
        )}

        <hr className="post-separator" />

        <div className="post-content">
          <ContentRenderer content={post.content} />
        </div>

        <div className="post-footer">
          <Link to="/" className="post-footer-link">tümü</Link>
          <span className="post-footer-slug">#{post.slug}</span>
        </div>
      </article>
    </div>
  );
};

export default PostPage;
